//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.NcmSubopBuilder.js";
let d=[[[0,"CutcomOff",1,0],[0,"CutcomOn",1,0],[0,"CutcomReg",1,0],[0,"CutcomRegBuilder",0,"CAM.InheritableIntBuilder",0],[0,"CutcomRegisterFlag",1,0],[0,"FromPointBuilder",0,"CAM.WedmPointDefinitionBuilder",0],[0,"GlobalStopPointDistanceBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"GlobalStopPointMethod",1,0],[0,"GlobalStopPointType",1,0],[0,"GoHomePointBuilder",0,"CAM.WedmPointDefinitionBuilder",0],[0,"LeadInAngleBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"LeadInCutcomAngleBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"LeadInCutcomDistanceBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"LeadInDistanceBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"LeadInMethod",1,0],[0,"LeadOutAngleBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"LeadOutCutcomAngleBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"LeadOutCutcomDistanceBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"LeadOutDistanceBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"LeadOutMethod",1,0],[0,"LeadOutSameAsLeadIn",1,0],[0,"NonTiltLeadIn",1,0]],[],[]];
SPLM.CAM.NcmWedmBuilder = class extends SPLM.CAM.NcmSubopBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.NcmWedmBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.NcmWedmBuilder.NonTiltLeadInTypes = Object.freeze({
    "Zm" : "Zm", "FourAxis" : "FourAxis"});

SPLM.CAM.NcmWedmBuilder.LeadInMethodTypes = Object.freeze({
    "Direct" : "Direct", "Angular" : "Angular", "Circular" : "Circular"});

SPLM.CAM.NcmWedmBuilder.LeadOutMethodTypes = Object.freeze({
    "SameAsLeadIn" : "SameAsLeadIn", "Direct" : "Direct", "Angular" : "Angular", "Circular" : "Circular"});

SPLM.CAM.NcmWedmBuilder.CutcomOnTypes = Object.freeze({
    "None" : "None", "BeforeLeadIn" : "BeforeLeadIn", "AfterLeadIn" : "AfterLeadIn", "AtThreadPoint" : "AtThreadPoint"});

SPLM.CAM.NcmWedmBuilder.CutcomOffTypes = Object.freeze({
    "None" : "None", "BeforeLeadOut" : "BeforeLeadOut", "AfterLeadOut" : "AfterLeadOut", "BeforeThreadPoint" : "BeforeThreadPoint"});

SPLM.CAM.NcmWedmBuilder.GlobalStopPointMethodTypes = Object.freeze({
    "None" : "None", "Specify" : "Specify"});

SPLM.CAM.NcmWedmBuilder.GlobalStopPointTypes = Object.freeze({
    "Opstop" : "Opstop", "Stop" : "Stop"});

SPLM.CAM.NcmWedmBuilder.LeadOutSameAsLeadInTypes = Object.freeze({
    "No" : "No", "Yes" : "Yes"});

export default SPLM;